import { lazy } from "react";

const HomePage = lazy(() => import("./unit-measurements-page"));

const routes = [
  {
    path: "/unit-measurements",
    component: HomePage,
    exact: true,
    name: "Unidades de Medida de Dietas de Nutrición"
  }
];

export default routes;
